<script lang="ts" setup>
import {useRoute} from 'vue-router';
import {provideModalFunctions} from '~/composables/useModal';

const route = useRoute()
provideModalFunctions();

defineProps({
  title: {
    type: String,
    default: 'Eventos'
  }
})
</script>

<template>
  <NuxtLayout>
    <Head>
      <Title>Seu Rolê | {{ route.meta.title }}</Title>
      <link rel='icon' type='image/png' href='/favicon.png'>
    </Head>
    <NuxtPage/>
  </NuxtLayout>
</template>
